import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBadge from 'UIComponents/badge/UIBadge';
import { jsx as _jsx } from "react/jsx-runtime";
const BestValueBadge = ({
  className,
  message = 'bestValue'
}) => {
  return /*#__PURE__*/_jsx(UIBadge, {
    use: "new",
    className: className,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `badges.${message}`
    })
  });
};
export default BestValueBadge;